__turbopack_context__.v({
  "SPlayerContainer": "nC3BNa_SPlayerContainer",
  "SYTIframe": "nC3BNa_SYTIframe",
});
